import { render, staticRenderFns } from "./organizationalStructure.vue?vue&type=template&id=0e8e10c6&scoped=true&"
import script from "./organizationalStructure.vue?vue&type=script&lang=js&"
export * from "./organizationalStructure.vue?vue&type=script&lang=js&"
import style0 from "./organizationalStructure.vue?vue&type=style&index=0&id=0e8e10c6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8e10c6",
  null
  
)

export default component.exports